// Lesson 3: Umur dan Pekerjaan - Vocabulary Data
export interface Word {
    id: number;
    batak: string;
    latin: string[];
    indonesia: string;
    syllable_mapping: Array<{
        batak_char: string;
        latin: string;
    }>;
}

// Vocabulary for Lesson 3: Umur dan Pekerjaan (Age and Occupation)
export const unit1Lesson3VocabularyBank: Word[] = [
    {
        id: 301,
        batak: "ᯖᯮᯀ",
        latin: ["tu", "a"],
        indonesia: "Umur",
        syllable_mapping: [
            { batak_char: "ᯖᯮ", latin: "tu" },
            { batak_char: "ᯀ", latin: "a" }
        ]
    },
    {
        id: 302,
        batak: "ᯇᯪᯒᯬ",
        latin: ["pi", "ro"],
        indonesia: "Berapa",
        syllable_mapping: [
            { batak_char: "ᯇᯪ", latin: "pi" },
            { batak_char: "ᯒᯬ", latin: "ro" }
        ]
    },
    {
        id: 303,
        batak: "ᯖᯮᯀᯔᯮ",
        latin: ["tu", "a", "mu"],
        indonesia: "Umurmu",
        syllable_mapping: [
            { batak_char: "ᯖᯮ", latin: "tu" },
            { batak_char: "ᯀ", latin: "a" },
            { batak_char: "ᯔᯮ", latin: "mu" }
        ]
    },
    {
        id: 304,
        batak: "ᯇᯰᯎᯀᯝᯮᯘ ᯉᯪ ᯅᯎᯘ",
        latin: ["pang", "ga", "lus", "ni", "ba", "gas"],
        indonesia: "Pekerjaan",
        syllable_mapping: [
            { batak_char: "ᯇᯰ", latin: "pang" },
            { batak_char: "ᯎᯀ", latin: "ga" },
            { batak_char: "ᯝᯮᯘ", latin: "lus" },
            { batak_char: "ᯉᯪ", latin: "ni" },
            { batak_char: "ᯅ", latin: "ba" },
            { batak_char: "ᯎᯘ", latin: "gas" }
        ]
    },
    {
        id: 305,
        batak: "ᯇᯀᯒᯎᯮᯒᯬᯉ᯲",
        latin: ["par", "gu", "ron"],
        indonesia: "Pelajar",
        syllable_mapping: [
            { batak_char: "ᯇᯀᯒ", latin: "par" },
            { batak_char: "ᯎᯮ", latin: "gu" },
            { batak_char: "ᯒᯬᯉ᯲", latin: "ron" }
        ]
    },
    {
        id: 306,
        batak: "ᯎᯮᯒᯮ",
        latin: ["gu", "ru"],
        indonesia: "Guru",
        syllable_mapping: [
            { batak_char: "ᯎᯮ", latin: "gu" },
            { batak_char: "ᯒᯮ", latin: "ru" }
        ]
    },
    {
        id: 307,
        batak: "ᯖᯀᯬᯉ᯲",
        latin: ["ta", "on"],
        indonesia: "Tahun",
        syllable_mapping: [
            { batak_char: "ᯖᯀ", latin: "ta" },
            { batak_char: "ᯬᯉ᯲", latin: "on" }
        ]
    },
    {
        id: 308,
        batak: "ᯖᯮᯀᯃᯮ",
        latin: ["tu", "a", "ku"],
        indonesia: "Umurku",
        syllable_mapping: [
            { batak_char: "ᯖᯮ", latin: "tu" },
            { batak_char: "ᯀ", latin: "a" },
            { batak_char: "ᯃᯮ", latin: "ku" }
        ]
    },
    {
        id: 309,
        batak: "ᯇᯃᯮᯔᯀᯘ",
        latin: ["par", "ka", "mas"],
        indonesia: "Pekerja",
        syllable_mapping: [
            { batak_char: "ᯇᯃ", latin: "par" },
            { batak_char: "ᯃᯮ", latin: "ka" },
            { batak_char: "ᯔᯀᯘ", latin: "mas" }
        ]
    },
    // Numbers for age
    {
        id: 310,
        batak: "ᯘᯑ",
        latin: ["sa", "da"],
        indonesia: "Satu",
        syllable_mapping: [
            { batak_char: "ᯘ", latin: "sa" },
            { batak_char: "ᯑ", latin: "da" }
        ]
    },
    {
        id: 311,
        batak: "ᯑᯮᯀ",
        latin: ["du", "a"],
        indonesia: "Dua",
        syllable_mapping: [
            { batak_char: "ᯑᯮ", latin: "du" },
            { batak_char: "ᯀ", latin: "a" }
        ]
    },
    {
        id: 312,
        batak: "ᯖᯬᯞᯮ",
        latin: ["to", "lu"],
        indonesia: "Tiga",
        syllable_mapping: [
            { batak_char: "ᯖᯬ", latin: "to" },
            { batak_char: "ᯞᯮ", latin: "lu" }
        ]
    },
    {
        id: 313,
        batak: "ᯀᯬᯇᯖ",
        latin: ["o", "pat"],
        indonesia: "Empat",
        syllable_mapping: [
            { batak_char: "ᯀᯬ", latin: "o" },
            { batak_char: "ᯇᯖ", latin: "pat" }
        ]
    },
    {
        id: 314,
        batak: "ᯞᯪᯔ",
        latin: ["li", "ma"],
        indonesia: "Lima",
        syllable_mapping: [
            { batak_char: "ᯞᯪ", latin: "li" },
            { batak_char: "ᯔ", latin: "ma" }
        ]
    },
    {
        id: 315,
        batak: "ᯀᯬᯉᯬᯔᯬ",
        latin: ["o", "no", "m"],
        indonesia: "Enam",
        syllable_mapping: [
            { batak_char: "ᯀᯬ", latin: "o" },
            { batak_char: "ᯉᯬ", latin: "no" },
            { batak_char: "ᯔᯬ", latin: "m" }
        ]
    },
    {
        id: 316,
        batak: "ᯇᯪᯖᯮ",
        latin: ["pi", "tu"],
        indonesia: "Tujuh",
        syllable_mapping: [
            { batak_char: "ᯇᯪ", latin: "pi" },
            { batak_char: "ᯖᯮ", latin: "tu" }
        ]
    },
    {
        id: 317,
        batak: "ᯥᯀᯞᯮ",
        latin: ["ua", "lu"],
        indonesia: "Delapan",
        syllable_mapping: [
            { batak_char: "ᯥᯀ", latin: "ua" },
            { batak_char: "ᯞᯮ", latin: "lu" }
        ]
    },
    {
        id: 318,
        batak: "ᯘᯪᯀ",
        latin: ["si", "a"],
        indonesia: "Sembilan",
        syllable_mapping: [
            { batak_char: "ᯘᯪ", latin: "si" },
            { batak_char: "ᯀ", latin: "a" }
        ]
    },
    {
        id: 319,
        batak: "ᯘᯔ᯲ᯇᯮᯞᯮ",
        latin: ["sam", "pu", "lu"],
        indonesia: "Sepuluh",
        syllable_mapping: [
            { batak_char: "ᯘ", latin: "sam" },
            { batak_char: "ᯔ᯲", latin: "pu" },
            { batak_char: "ᯇᯮᯞᯮ", latin: "lu" }
        ]
    },
    {
        id: 320,
        batak: "ᯑᯮᯀ ᯇᯮᯞᯮᯂ",
        latin: ["du", "a", "pu", "luh"],
        indonesia: "Dua puluh",
        syllable_mapping: [
            { batak_char: "ᯑᯮᯀ", latin: "dua" },
            { batak_char: "ᯇᯮᯞᯮᯂ", latin: "puluh" }
        ]
    },
    {
        id: 321,
        batak: "ᯑᯮᯀ ᯇᯮᯞᯮᯂ ᯞᯪᯔ",
        latin: ["du", "a", "pu", "luh", "li", "ma"],
        indonesia: "Dua puluh lima",
        syllable_mapping: [
            { batak_char: "ᯑᯮᯀ", latin: "dua" },
            { batak_char: "ᯇᯮᯞᯮᯂ", latin: "puluh" },
            { batak_char: "ᯞᯪᯔ", latin: "lima" }
        ]
    }
];


// Extended word bank for sentence composition
export const unit1Lesson3ExtendedWordBank: Word[] = [
    ...unit1Lesson3VocabularyBank,
    // Include some words from previous lessons
    {
        id: 105,
        batak: "ᯀᯮ",
        latin: ["au"],
        indonesia: "Saya",
        syllable_mapping: [
            { batak_char: "ᯀᯮ", latin: "au" }
        ]
    },
    {
        id: 106,
        batak: "ᯂᯬ",
        latin: ["ho"],
        indonesia: "Kamu",
        syllable_mapping: [
            { batak_char: "ᯂᯬ", latin: "ho" }
        ]
    },
    {
        id: 107,
        batak: "ᯤᯀ",
        latin: ["i", "a"],
        indonesia: "Dia",
        syllable_mapping: [
            { batak_char: "ᯤ", latin: "i" },
            { batak_char: "ᯀ", latin: "a" }
        ]
    },
    {
        id: 209,
        batak: "ᯑᯬ",
        latin: ["do"],
        indonesia: "adalah/dari",
        syllable_mapping: [
            { batak_char: "ᯑᯬ", latin: "do" }
        ]
    },
    {
        id: 322,
        batak: "ᯇᯘᯑᯀᯎᯀᯰ",
        latin: ["pe", "da", "gang"],
        indonesia: "Pedagang",
        syllable_mapping: [
            { batak_char: "ᯇᯘ", latin: "pe" },
            { batak_char: "ᯑᯀ", latin: "da" },
            { batak_char: "ᯎᯀᯰ", latin: "gang" }
        ]
    },
    {
        id: 323,
        batak: "ᯇᯎᯀᯤᯝ",
        latin: ["pe", "ga", "wai"],
        indonesia: "Pegawai",
        syllable_mapping: [
            { batak_char: "ᯇᯎ", latin: "pe" },
            { batak_char: "ᯀᯤ", latin: "ga" },
            { batak_char: "ᯝ", latin: "wai" }
        ]
    },
    {
        id: 999,
        batak: "",
        latin: ["."],
        indonesia: "",
        syllable_mapping: [{ batak_char: ".", latin: "-" }],
    }
];

// Sample sentences for lesson 3
export const lesson3Sentences = [
    {
        id: 1,
        batak: "ᯖᯮᯀᯃᯮ ᯞᯪᯔ ᯖᯀᯬᯉ᯲.",
        latin: "Tuaku lima taon.",
        indonesia: "Umurku lima tahun.",
        wordIds: [308, 314, 307]
    },
    {
        id: 2,
        batak: "ᯇᯰᯎᯀᯝᯮᯘ ᯉᯪ ᯅᯎᯘ ᯀᯮ ᯎᯮᯒᯮ.",
        latin: "Panggalus ni bagas au guru.",
        indonesia: "Pekerjaan saya guru.",
        wordIds: [304, 105, 306]
    },
    {
        id: 3,
        batak: "ᯂᯬ ᯑᯬ ᯇᯀᯒᯎᯮᯒᯬᯉ᯲?",
        latin: "Ho do parguron?",
        indonesia: "Apakah kamu pelajar?",
        wordIds: [106, 209, 305]
    },
    {
        id: 4,
        batak: "ᯤᯀ ᯑᯬ ᯎᯮᯒᯮ.",
        latin: "Ia do guru.",
        indonesia: "Dia adalah guru.",
        wordIds: [107, 209, 306]
    },
    {
        id: 5,
        batak: "ᯇᯪᯒᯬ ᯑᯬ ᯖᯮᯀᯔᯮ?",
        latin: "Piro do tuamu?",
        indonesia: "Berapa umurmu?",
        wordIds: [302, 209, 303]
    }
];

// Helper function to create word dictionary
export const createLesson3WordDict = (wordBank: Word[]) => {
    return Object.fromEntries(wordBank.map((w) => [w.id, w]));
};
